import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { APP_ACTIONS, APP_STATES } from "@config";
import {
  ApplicationsActions,
  selectCurrentApplicationId,
  selectCurrentApplicationActions,
  selectCurrentApplicationState
} from "@redux";
import { i18 } from "@utilities";

export const MODAL_KEYS = {
  REJECT_APP: "rejectApp",
  ADDITIONAL_DOCS: "additionalDocs",
  ADD_RISK: "addRisk",
  RISK_APPROVE: "riskApprove",
  APPROVE_BENEFICIARES: "approveBeneficiares",
  REJECT_DUE_SANCTIONS: "rejectDueSanctions",
  REJECT_UPLOAD_AGREEMENT: "rejectUploadAgreement",
  APPROVE_UPLOAD_AGREEMENT: "approveUploadAgreement"
};

const useActionHandler = () => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const appActions = useSelector(selectCurrentApplicationActions);
  const currentState = useSelector(selectCurrentApplicationState);

  // this effect is used to clear approve
  // beneficieries button on waiting for beneficiary docs state
  useEffect(() => {
    if (currentState !== APP_STATES.WAITING_FOR_BENEFICIARY_DOCS) return;

    const newActions = appActions.filter(
      action => action.name !== APP_ACTIONS.APPROVE_BENEFICIERES
    );
    dispatch(ApplicationsActions.modifyAppActions(newActions));
  }, [currentState]);

  const [isModalOpen, setIsModalOpen] = useState({
    [MODAL_KEYS.REJECT_APP]: false,
    [MODAL_KEYS.ADDITIONAL_DOCS]: false,
    [MODAL_KEYS.ADD_RISK]: false,
    [MODAL_KEYS.RISK_APPROVE]: false,
    [MODAL_KEYS.APPROVE_BENEFICIARES]: false,
    [MODAL_KEYS.REJECT_DUE_SANCTIONS]: false,
    [MODAL_KEYS.REJECT_UPLOAD_AGREEMENT]: false,
    [MODAL_KEYS.APPROVE_UPLOAD_AGREEMENT]: false
  });

  const toggleActionModal = key => {
    setIsModalOpen({
      ...isModalOpen,
      [key]: !isModalOpen[key]
    });
  };

  const handleAllSanctionsReviewed = async () => {
    await dispatch(
      ApplicationsActions.allSanctionReviewed(appId, i18.NotificationTitles.SuccessOperation)
    );
  };

  const handleAction = actionName => {
    switch (actionName) {
      case APP_ACTIONS.APPROVE_BENEFICIERES:
        toggleActionModal(MODAL_KEYS.APPROVE_BENEFICIARES);
        break;
      case APP_ACTIONS.REJECT_DUE_SANCTIONS:
        toggleActionModal(MODAL_KEYS.REJECT_DUE_SANCTIONS);
        break;
      case APP_ACTIONS.REJECT_APP:
        toggleActionModal(MODAL_KEYS.REJECT_APP);
        break;
      case APP_ACTIONS.ADD_RISK:
        toggleActionModal(MODAL_KEYS.ADD_RISK);
        break;
      case APP_ACTIONS.APPROVE_RISK:
        toggleActionModal(MODAL_KEYS.RISK_APPROVE);
        break;
      case APP_ACTIONS.ALL_SANCTIONS_REVIEWED:
        handleAllSanctionsReviewed();
        break;
      case APP_ACTIONS.REQUEST_ADDITIONAL_DOCS:
        toggleActionModal(MODAL_KEYS.ADDITIONAL_DOCS);
        break;
      case APP_ACTIONS.REJECT_UPLOAD_AGREEMENT:
        toggleActionModal(MODAL_KEYS.REJECT_UPLOAD_AGREEMENT);
        break;
      case APP_ACTIONS.CONFIRM_UPLOAD_AGREEMENT:
        toggleActionModal(MODAL_KEYS.APPROVE_UPLOAD_AGREEMENT);
        break;
      default:
        break;
    }
  };

  return [appActions || [], isModalOpen, handleAction, toggleActionModal];
};

export default useActionHandler;
